module.exports = __webpack_public_path__ + "img/idea-2.20014c00.png";